import { render, staticRenderFns } from "./UserWalletPage.vue?vue&type=template&id=d09f0cee&"
import script from "./UserWalletPage.vue?vue&type=script&lang=js&"
export * from "./UserWalletPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports